/**
 * Formats any valid date string into "DD MMM, YYYY"
 * @param dateString - Any valid date string (e.g. "27/8/2025", "2025-08-27", "Aug 27, 2025")
 * @returns Formatted date string like "27 Aug, 2025" or original string if invalid
 */
export function formatDateString(dateString: string): string {
    if (!dateString || typeof dateString !== 'string') {
        return dateString
    }

    try {
        // Try to parse directly
        let date = new Date(dateString)

        // If the string is in DD/MM/YYYY or DD/M/YYYY, JS Date may misinterpret it as MM/DD
        if (!isNaN(Number(dateString.split('/')[0])) && dateString.includes('/')) {
            const parts = dateString.split('/')
            if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
                const day = parseInt(parts[0], 10)
                const month = parseInt(parts[1], 10) - 1
                const year = parseInt(parts[2], 10)
                date = new Date(year, month, day)
            }
        }

        // Check for invalid dates
        if (isNaN(date.getTime())) {
            return dateString
        }

        return date
            .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            })
            .replace(/\s/g, ' ') // Ensure spacing is consistent
    } catch {
        return dateString
    }
}
